import { render, staticRenderFns } from "./CourtagenPage.vue?vue&type=template&id=7ce56f46&"
import script from "./CourtagenPage.vue?vue&type=script&lang=js&"
export * from "./CourtagenPage.vue?vue&type=script&lang=js&"
import style0 from "./CourtagenPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAutocomplete,VDataTable,VDivider,VIcon})
